export default __webpack_public_path__ + "992cf1d34fb7a6bde5b12f60d37d6d5d.png";